/**
 * Tema Univalle 2026
 * Entry point principal de JavaScript (Vanilla JS + Drupal Behaviors)
 */

(function (Drupal, once) {

    'use strict';

    /**
     * Comportamiento para la pausa / reanudación estricta de Carruseles (Home y Nodo)
     * Cumplimiento WCAG 2.1 AA — Criterio 2.2.2 (Pausa, Detención, Ocultamiento)
     */
    Drupal.behaviors.bannerCarouselPause = {
        attach: function (context) {
            const pauseButtons = once('banner-pause-toggle', '.banner-home__pause, .banner-nodo__pause', context);

            pauseButtons.forEach(function (button) {
                const carouselId = button.getAttribute('data-carousel-id');
                if (!carouselId) return;

                const carouselElement = document.getElementById(carouselId);
                if (!carouselElement) return;

                // Listener del botón de Pausa / Play
                button.addEventListener('click', function () {
                    let carouselInstance = bootstrap.Carousel.getInstance(carouselElement);
                    if (!carouselInstance) {
                        carouselInstance = new bootstrap.Carousel(carouselElement);
                    }

                    const isPaused = button.getAttribute('data-paused') === 'true';
                    const pauseIcon = button.querySelector('.fa-pause');
                    const playIcon = button.querySelector('.fa-play');

                    if (isPaused) {
                        // REANUDAR: Reactiva el auto-ride y arranca el ciclo
                        button.setAttribute('data-paused', 'false');
                        button.setAttribute('aria-label', Drupal.t('Pausar carrusel'));

                        if (pauseIcon) pauseIcon.classList.remove('d-none');
                        if (playIcon) playIcon.classList.add('d-none');

                        carouselInstance._config.ride = 'carousel';
                        carouselInstance.cycle();
                    } else {
                        // PAUSAR: Desactiva el auto-ride maestro y detiene el temporizador
                        button.setAttribute('data-paused', 'true');
                        button.setAttribute('aria-label', Drupal.t('Reanudar carrusel'));

                        if (pauseIcon) pauseIcon.classList.add('d-none');
                        if (playIcon) playIcon.classList.remove('d-none');

                        carouselInstance._config.ride = false;
                        carouselInstance.pause();
                    }
                });
            });
        }
    };

    /**
     * Comportamiento para el Patrón Facade de Videos de YouTube (Home y Nodo)
     * Reemplaza el iframe inicial por portada HD con fallback y gestiona
     * el ciclo de reproducción, pausa reactiva y desacople de estados (Fase C).
     */
    Drupal.behaviors.bannerYoutubeFacade = {
        attach: function (context) {
            const facades = once('banner-youtube-facade', '[data-youtube-facade]', context);

            // Escuchador Global Bidireccional: Detecta cuando el usuario reanuda el video DENTRO del iframe
            if (!window.bannerYoutubeMessageListenerAttached) {
                window.addEventListener('message', function (event) {
                    if (typeof event.origin === 'string' && !event.origin.includes('youtube')) {
                        return;
                    }
                    let data;
                    try {
                        data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
                    } catch (e) {
                        return;
                    }

                    // infoDelivery con playerState 1 (PLAYING) o 3 (BUFFERING): Congela de inmediato el carrusel
                    if (data && data.event === 'infoDelivery' && data.info && (data.info.playerState === 1 || data.info.playerState === 3)) {
                        const activeCarousels = document.querySelectorAll('.banner-home.carousel, .banner-nodo.carousel');
                        activeCarousels.forEach(function (carouselElement) {
                            if (carouselElement.querySelector('iframe') && window.bootstrap && bootstrap.Carousel) {
                                let carouselInstance = bootstrap.Carousel.getInstance(carouselElement);
                                if (!carouselInstance) {
                                    carouselInstance = new bootstrap.Carousel(carouselElement);
                                }
                                carouselInstance._config.ride = false;
                                carouselInstance.pause();
                                carouselElement.classList.add('is-video-playing');
                            }
                        });
                    }
                });
                window.bannerYoutubeMessageListenerAttached = true;
            }

            facades.forEach(function (facade) {
                const videoId = facade.getAttribute('data-youtube-id');
                if (!videoId) return;

                const videoTitle = facade.getAttribute('data-youtube-title') || Drupal.t('Video institucional');
                const img = facade.querySelector('[data-youtube-img]');
                const carouselElement = facade.closest('.carousel');

                // 1. Fallback universal de miniaturas: maxresdefault.jpg -> hqdefault.jpg
                if (img) {
                    const applyFallback = function () {
                        if (!img.dataset.fallbackApplied) {
                            img.dataset.fallbackApplied = 'true';
                            img.src = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
                        }
                    };

                    // Caso A: Error 404 en la red
                    img.onerror = applyFallback;

                    // Caso B: YouTube devuelve imagen gris de 120x90 con HTTP 200
                    img.onload = function () {
                        if (img.naturalWidth === 120 && img.naturalHeight === 90) {
                            applyFallback();
                        }
                    };

                    // Caso C: Imagen ya en caché del navegador
                    if (img.complete && img.naturalWidth === 120 && img.naturalHeight === 90) {
                        applyFallback();
                    }
                }


                // 2. Escuchador de salida de diapositiva (slide.bs.carousel):
                // Pausa el video al instante y reanuda el ciclo solo si no estaba pausado por el usuario
                if (carouselElement && !carouselElement.dataset.videoSlideListenerAttached) {
                    carouselElement.addEventListener('slide.bs.carousel', function () {
                        // A. Cortar audio en 0 ms pausando el video de YouTube en su timestamp exacto
                        const iframes = carouselElement.querySelectorAll('iframe');
                        iframes.forEach(function (iframe) {
                            if (iframe.contentWindow) {
                                iframe.contentWindow.postMessage(JSON.stringify({
                                    event: 'command',
                                    func: 'pauseVideo',
                                    args: ''
                                }), '*');
                            }
                        });

                        // B. Retirar clase contextual de video en móvil
                        carouselElement.classList.remove('is-video-playing');

                        // C. Desacople: Reanudar ciclo SOLO si el usuario no había presionado Pausa
                        const pauseBtn = carouselElement.querySelector('.banner-home__pause, .banner-nodo__pause');
                        const isUserExplicitlyPaused = pauseBtn && pauseBtn.getAttribute('data-paused') === 'true';

                        if (!isUserExplicitlyPaused && window.bootstrap && bootstrap.Carousel) {
                            let carouselInstance = bootstrap.Carousel.getInstance(carouselElement);
                            if (carouselInstance) {
                                carouselInstance._config.ride = 'carousel';
                                carouselInstance.cycle();
                            }
                        }
                    });
                    carouselElement.dataset.videoSlideListenerAttached = 'true';
                }

                // 3. Función ejecutora del reemplazo por el iframe de YouTube
                const loadIframe = function () {
                    const iframe = document.createElement('iframe');
                    iframe.src = `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&enablejsapi=1&rel=0`;
                    iframe.title = videoTitle;
                    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; compute-pressure';
                    iframe.allowFullscreen = true;
                    iframe.className = 'w-100 h-100 border-0';

                    // Inicializar escucha bidireccional al cargar el iframe
                    iframe.onload = function () {
                        if (iframe.contentWindow) {
                            iframe.contentWindow.postMessage(JSON.stringify({ event: 'listening' }), '*');
                        }
                    };

                    // A. Detención automática de la auto-rotación del carrusel para dejar ver el video
                    if (carouselElement && window.bootstrap && bootstrap.Carousel) {
                        let carouselInstance = bootstrap.Carousel.getInstance(carouselElement);
                        if (!carouselInstance) {
                            carouselInstance = new bootstrap.Carousel(carouselElement);
                        }
                        carouselInstance._config.ride = false;
                        carouselInstance.pause();

                        // B. Activar clase contextual para despejar controles en móviles (< 768px)
                        carouselElement.classList.add('is-video-playing');
                    }

                    // C. Inserción del iframe en el DOM
                    const parent = facade.parentElement;
                    if (parent) {
                        parent.replaceChild(iframe, facade);
                        iframe.focus();
                    }
                };

                // 4. Evento Clic (Ratón / Pantalla táctil)
                facade.addEventListener('click', function (e) {
                    e.preventDefault();
                    loadIframe();
                });

                // 5. Accesibilidad: Evento Teclado (Enter o Espacio)
                const playBtn = facade.querySelector('button');
                if (playBtn) {
                    playBtn.addEventListener('keydown', function (e) {
                        if (e.key === 'Enter' || e.key === ' ' || e.code === 'Space') {
                            e.preventDefault();
                            loadIframe();
                        }
                    });
                }
            });
        }
    };




    /**
     * Comportamiento Optimizado para Desplegables de Vistas en Sidebar (.js-fix-dropdown)
     * Relocaliza atómicamente las filas (.js-item) al menú (.js-menu) con accesibilidad WCAG 2.1
     */
    Drupal.behaviors.fixDropdownSidebar = {
        attach: function (context) {
            const dropdowns = once('fix-dropdown-sidebar', '.js-fix-dropdown', context);

            dropdowns.forEach(function (dropdown) {
                const target = dropdown.querySelector('.js-menu');
                const items = dropdown.querySelectorAll('.js-item');

                if (target && items.length > 0) {
                    const fragment = document.createDocumentFragment();

                    items.forEach(function (item) {
                        // Garantiza accesibilidad para lectores de pantalla
                        item.setAttribute('role', 'menuitem');
                        fragment.appendChild(item);
                    });

                    // Inyección atómica única (0 ms de reflow)
                    target.appendChild(fragment);
                }
            });
        }
    };

    /**
     * Supresión Automática de Card Footers Vacíos en Vistas
     * Oculta el .card-footer si su contenido solo contiene espacios en blanco o saltos de línea.
     */
    Drupal.behaviors.suppressEmptyCardFooters = {
        attach: function (context) {
            const footers = once('suppress-empty-card-footers', '.card-footer', context);

            footers.forEach(function (footer) {
                // Si no hay texto visible después de quitar espacios (.trim()), oculta el footer
                if (!footer.textContent.trim()) {
                    footer.style.display = 'none';
                }
            });
        }
    };

    /**
     * Alternador de Modo Oscuro / Modo Claro
     */
    Drupal.behaviors.themeToggle = {
        attach: function (context) {
            const btn = once('theme-toggle', '#theme-toggle', context)[0];
            if (!btn) return;

            const applyTheme = (theme) => {
                const isDark = theme === 'dark';
                document.documentElement.setAttribute('data-bs-theme', theme);
                localStorage.setItem('theme', theme);
                btn.querySelector('i').className = isDark ? 'fa-solid fa-sun' : 'fa-solid fa-moon';
                btn.setAttribute('aria-pressed', isDark ? 'true' : 'false');
                const labelText = isDark ? Drupal.t('Cambiar a modo claro') : Drupal.t('Cambiar a modo oscuro');
                btn.setAttribute('aria-label', labelText);
                btn.setAttribute('title', labelText);
            };

            applyTheme(localStorage.getItem('theme') || 'light');
            btn.onclick = () => applyTheme(document.documentElement.getAttribute('data-bs-theme') === 'dark' ? 'light' : 'dark');
        }
    };



})(Drupal, once);
